<template>
  <SogAppBar>
    <SogButton
      mdi-icon="mdi-menu"
      :type="SogButtonType.Appbar"
      @click="onMenuClick"
    />
    <SogButton
      :type="SogButtonType.Appbar"
      @click="onRootClick"
    >
      {{ _shopName }}
    </SogButton>
    <SogButton
      v-show="_accountStore.isBranch"
      :type="SogButtonType.Appbar"
      mdi-icon="mdi-cart-plus"
      tooltip="Einzeleinkauf"
      @click="p_onPurchase"
    />
    <SogAppBarSpacer />
    <SogButton
      v-show="authenticated!==true"
      mdi-icon="mdi-login"
      :type="SogButtonType.Appbar"
      @click="onLoginClick"
    >
      Anmelden
    </SogButton>
    <!--
    <SogButton
        mdi-icon="mdi-theme-light-dark"
        :type="SogButtonType.Appbar"
        @click="onThemeClick"
    />
-->
    <SogMenu
      v-show="authenticated"
      :items="_accountMenuItems"
      @select="onAccountSelect"
    />
    <!--    <SogDropDownButton
      v-show="authenticated"
      mdi-icon="mdi-account"
      :items="_accountItems"
      :type="SogDropDownButtonType.Appbar"
      @select="onAccountSelect"
    >
      {{ _personName }}
    </SogDropDownButton>-->
  </SogAppBar>
</template>

<script setup lang="ts">

import SogAppBar from "@/shared/ui/SogAppBar.vue";
import SogAppBarSpacer from "@/shared/ui/SogAppBarSpacer.vue";
import {useAccountStore} from "@/stores/accountStore";
import {storeToRefs} from "pinia";
import router from "@/app/routes";
import apiAuth from "@/shared/services/apiAuth";
import {computed} from "vue";
import SogDropDownButtonItem from "@/shared/ui/types/SogDropDownButtonItem";
import SogButton from "@/shared/ui/SogButton.vue";
import {SogButtonType} from "@/shared/ui/types/SogButtonType";
import SogMenu from "@/shared/ui/SogMenu.vue";
import {reactive, watch} from "vue";
import {mdiAccount} from "@mdi/js";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";


const _emits = defineEmits(['menuClick']);
const _accountStore = useAccountStore();
const {actionPerson} = storeToRefs(_accountStore)
const {authenticated} = storeToRefs(_accountStore)
const {installation} = storeToRefs(_accountStore)
const _accountItems: SogDropDownButtonItem[] = [{text: "Abmelden", id: "logout"}]
const _themeStore = useAccountStore()
const _accountMenuItems: SogDropDownButtonItem[] = reactive([{
  text: "", id: "1",
  svgIcon: mdiAccount,
  items: [{text: "Abmelden", id: "logout", svgIcon: mdiAccount}]
}])

const _personName = computed(() => {
  return actionPerson.value?.personName
})

const _shopName = computed(() => {
  return installation.value?.shortName
})

watch(actionPerson, (value) => {
  _accountMenuItems[0].text = actionPerson.value?.personName
}, {immediate: true})

const companyMenuItems = [
  {
    text: 'Company',
    items: [
      {text: 'About Us'},
      {text: 'Customers'},
      {text: 'Blog'},
      {text: 'Careers'}
    ]
  }
]


function onRootClick() {
  router.push("/");
  /*
    if (installation.value.shopId === "eVB_Aktivierung") {
      router.push("/");
    } else {
      window.open("https://www.agent22.eu", "_blank");
    }
  */
}

async function onLoginClick() {
  await apiAuth.login(undefined);
}

async function onAccountSelect(item: SogDropDownButtonItem) {
  if (item.id === "logout") {
    await apiAuth.logout();
    return
  }
}


function onMenuClick() {
  _emits("menuClick")
}

function onThemeClick() {
  _themeStore.dark = !_themeStore.dark;
}

async function p_onPurchase() {
  await router.push("/shoppingcartsingleproduct/purchase/producttype");
}

</script>

<style scoped>

</style>
